<template>
    <div class="section section--european-space hero">
        <div class="spring european-space--spring">
            <div class="european-space--text">
                <h3 class="heading heading--3 heading--light heading--leading">
                    Roaming în Spațiul <br />
                    Economic European (SEE)
                </h3>
                <p class="">Spațiul Economic European (SEE) sau Zona 1 este formată din țările membre ale Uniunii Europene, Norvegia, Islanda și Lichtenstein.</p>
                <br />
                <p class="heading heading--6 heading--regular heading--leading heading--trailing">Dacă vei călători în țări din afara SEE (de exemplu Turcia sau Moldova), verifică informațiile pentru celelalte țări non-SEE.</p>
                <br />
            </div>
            <div>
                <router-link to="tarife-standard" class="button button--primary button--inline no-gutter--bottom"> Vezi tabel zone roaming </router-link>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'EuropeanSpace',
};
</script>
